
import {
  defineComponent,
  onMounted,
  ref,
} from 'vue';

export default defineComponent({
  props: {
    threshold: {
      type: Number,
      required: false,
      default: () => 0,
    },
    clearOnEnter: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },

  emits: ['observeenter', 'observeleave'],

  setup(props, context) {
    const root = ref<InstanceType<typeof HTMLElement>>();

    const handleIntersect = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ): void => {
      let entered = false;

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entered = true;
        }
      });

      if (entered) {
        context.emit('observeenter', root.value);
        if (props.clearOnEnter && root.value) {
          observer.unobserve(root.value);
        }
      } else {
        context.emit('observeleave', root.value);
      }
    };

    const createObserver = (): void => {
      const observer = new IntersectionObserver(handleIntersect, {
        root: null,
        threshold: props.threshold,
      });

      if (root.value) {
        observer.observe(root.value);
      }
    };

    onMounted(() => {
      if (window.IntersectionObserver) {
        createObserver();
      } else {
        context.emit('observeenter', root.value);
      }
    });

    return {
      root,
    };
  },
});
